import ActionPanel from '../components/ActionPanel.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { HELP_PATH, watchHelpTopicPath } from '../navigation/paths.js';
import { watchTopics } from './watchTopics.jsx';

// The Watch App help's topic list — the app's WatchAppHelp/List.js as a web page.
// Pilot only (the route is behind FlagGate), as the app's Help menu has it; the
// app additionally shows it on Android alone, since the watch app is Wear OS, but
// a web browser has no platform to check, so here the flag is the whole gate.
export default function WatchHelpListScreen() {
  return (
    <main className="app-shell screen">
      <ScreenHeader
        title="Watch App"
        sub="How to use your smartwatch app"
        backTo={HELP_PATH}
        backLabel="Help"
      />
      <nav className="action-panel-list" aria-label="Watch App topics">
        {watchTopics.map(({ slug, title, icon }) => (
          <ActionPanel
            key={slug}
            to={watchHelpTopicPath(slug)}
            icon={icon}
            title={title}
          />
        ))}
      </nav>
    </main>
  );
}
